<script lang="ts" setup>
import ProgressSpinner from "primevue/progressspinner";

defineProps({
  text: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <div class="pointer-events-none flex flex-col items-center gap-2">
    <ProgressSpinner style="width: 50px; height: 50px" stroke-width="8" />
    <p v-if="text" class="select-none">{{ text }}</p>
  </div>
</template>

<style lang="postcss" scoped>
:deep(.p-progress-spinner-svg circle) {
  @apply animate-progress-spinner-custom;
}
</style>
